import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MidVoyageReportsComponent } from './mid-voyage-reports.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';


@NgModule({
  declarations: [
    MidVoyageReportsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    CustomDatePickerModule,
    CustomInputModule,
    CustomDropdownModule
  ],
  exports:[
    MidVoyageReportsComponent
  ]
})
export class MidVoyageReportsModule { }
